import { render } from "./ImageConfig.vue?vue&type=template&id=4cb9bf49&scoped=true&ts=true"
import script from "./ImageConfig.vue?vue&type=script&lang=ts"
export * from "./ImageConfig.vue?vue&type=script&lang=ts"

import "./ImageConfig.vue?vue&type=style&index=0&id=4cb9bf49&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb9bf49"]])

export default __exports__